skrilla.service('promotionService', function (validationService, cacheService, modalService) {
  var validation = validationService;

  function validatePromotion(promotion, validateObj) {
    var inputs = [
      validation.buildFieldValidationObj("name", !validation.isEmpty(promotion.name), "Please enter a name"),
      validation.buildFieldValidationObj("description", !validation.isEmpty(promotion.description), "Please enter a description"),
      validation.buildFieldValidationObj("ownerAmount", !validation.isEmpty(promotion.ownerAmount), "Please enter an Owner Amount"),
      validation.buildFieldValidationObj("claimerAmount", !validation.isEmpty(promotion.claimerAmount), "Please enter a Claimer Amount"),
      validation.buildFieldValidationObj("termsOfUse", validation.isEmpty(promotion.termsOfUse) || promotion.termsOfUse.startsWith("https://"), "Please enter a valid Terms Of Use link (https://)")
    ];
    return validation.validateForm(inputs, validateObj)
  }

  function getPurposes() {
    return {
      WINNINGS_BOOST: false,
      PROMOTION: false,
      DEPOSIT_BONUS: false,
      MULTI_CASHBACK: false,
      DEFAULT_DEPOSIT_BONUS: false,
      DEFAULT_REFERRAL: false,
      REFERRAL: false,
    };
  }

  function getCampaignProviders(){
      return {
        BRAZE: true,
        INTERNAL: true
      }
  }

  function getCampaignStatuses(){
    return {
      ACTIVE: true,
      COMPLETED: false
    }
  }

  function declineClaim(claimId, callback){
    cacheService.registerObject("declinePromotionClaim", claimId)
    modalService.openModal("views/promotionClaimDetails/declinePromotionClaim.html", true, 'lg', true, true, callback)
  }

  return {
    validatePromotion,
    getPurposes,
    getCampaignProviders: getCampaignProviders,
    getCampaignStatuses: getCampaignStatuses,
    declineClaim: declineClaim
  };
});
